import { useDataQueryResult } from '../../../plugin-system';
import { HeatMapPanelLoaded } from './HeatMapPanelLoaded';
import { HeatMapPanelProps } from './heat-map-model';

/**
 * Panel displaying a heatmap visualization
 */
export function HeatMapPanel(props: HeatMapPanelProps) {
  const { queryResults } = useDataQueryResult({ dataTypeFilter: 'HeatMap' });
  if (queryResults[0]?.error) throw queryResults[0]?.error;

  return <HeatMapPanelLoaded {...props} />;
}
